// Build-time app mode (plan 2124): REACT_APP_APP_MODE=hub builds the self-service hub
// SPA (/my only) that the Cloud Run `tec-hub` service serves. Anything else is the
// analytics SPA, unchanged.
export const IS_HUB = process.env.REACT_APP_APP_MODE === 'hub';
